import { gql } from '@apollo/client';

export type QueryResult = {
  request: Request;
};

export type Request = {
  id: string;
  requestComments: RequestComment[];
};

export type RequestComment = {
  id: string;
  actedUser: User;
  commentBy: string;
  comment: string;
  createdAt: string;
};

type User = {
  id: string;
  name: string;
};

export const FETCH_REQUEST_COMMENTS = gql`
  query fetchRequest {
    request {
      id
      requestComments {
        id
        actedUser {
          id
          name
        }
        commentBy
        comment
        createdAt
      }
    }
  }
`;
